<script>

import PcNews1 from "@/components/pc/PcNews1.vue";
import PcVideo from "@/components/pc/PcVideo.vue";
import PcVideo1 from "@/components/pc/PcVideo1.vue";
import PcNews from "@/components/pc/PcNews.vue";
import PcNews2 from "@/components/pc/PcNews2.vue";
import PcNews3 from "@/components/pc/PcNews3.vue";
import PcNews4 from "@/components/pc/PcNews4.vue";
export default({
  components:{
    PcNews1,PcVideo,PcVideo1,PcNews,PcNews2,PcNews3,PcNews4
  },
  props: {
    lists: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showNewsIndex: 0,
      showNews: false,
      videoShow: false,
      loadedImages: 0,
      totalWidth: 0,
      scrollPosition: 0,
      animationFrameId: null,

    };
  },

  beforeUnmount() {
    cancelAnimationFrame(this.animationFrameId);
  },
  methods: {
    onImageLoad(refName, imgListName, loadedCountKey, totalWidthKey, positionKey, frameIdKey) {
      this[loadedCountKey]++;
      const carousel = this.$refs[refName];
      if (this[loadedCountKey] === this[imgListName].length * 2) {
        this[totalWidthKey] = Array.from(carousel.children).reduce((sum, img) => sum + img.offsetWidth, 0);
        this.startCarousel(carousel, positionKey, totalWidthKey, frameIdKey);
      }
    },
    startCarousel(carousel, positionKey, widthKey, frameIdKey) {
      const animate = () => {
        this[positionKey] -= 1;
        if (Math.abs(this[positionKey]) >= this[widthKey] / 2) this[positionKey] = 0;
        carousel.style.transform = `translateX(${this[positionKey]}px)`;
        this[frameIdKey] = requestAnimationFrame(animate);
      };
      animate();
    },
    closeVideo() {
      this.videoShow = false;
    },
    onNewClick(type, url, id) {

      if (type === 1) {
        this.showNews = true;
        this.videoShow = false;

      } else if (type === 2) {
        this.videoShow = true;
        this.showNews = false;
      }
      this.showNewsIndex = id;
    }

  },
})
</script>

<template>
  <div class="carousel-container">
    <van-popup v-model="showNews" closeable>
      <div v-if="showNews" class="pc-news-view">
        <PcNews v-if="showNewsIndex===1"></PcNews>
        <PcNews1 v-if="showNewsIndex===3"></PcNews1>
        <PcNews2 v-if="showNewsIndex===5"></PcNews2>
        <PcNews3 v-if="showNewsIndex===6"></PcNews3>
        <PcNews4 v-if="showNewsIndex===7"></PcNews4>
      </div>
    </van-popup>

    <van-popup v-model="videoShow" closeable @close="closeVideo()">
      <div v-if="videoShow" class="pc-news-view">
        <PcVideo v-if="showNewsIndex===2"></PcVideo>
        <PcVideo1 v-if="showNewsIndex===4"></PcVideo1>
      </div>
    </van-popup>

    <div ref="carousel" class="carousel images">
      <div v-for="(item,index) in [...lists ,...lists]" class="news-item-layout" :key="`${item}:${index}`" @click="onNewClick(item.type,item.pcURL,item.id)">
        <img :src="item.imgUrl" @load="onImageLoad('carousel', 'lists', 'loadedImages', 'totalWidth', 'scrollPosition', 'animationFrameId')"
             class="news-image">
        <img v-if="item.type===2" class="play-icon" src="@/assets/video_paly.png">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="del">
          {{ item.desc }}
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped lang="scss">
.carousel-container {
  overflow: hidden;
  position: relative;



  .pc-news-view {
    padding-left: 160px;
    padding-right: 160px;
    width: 680px;
    height: 80vh;
    overflow: scroll;
  }

  .carousel {
    display: flex;
    //white-space: nowrap;

    .news-item-layout {
      flex-shrink: 0;
      position: relative;
      margin-top: 35px;

      .news-image {
        width: 310px;
        object-fit: cover;
        height: 210px;
      }

      .play-icon {
        position: absolute;
        top: 65px;
        left: 130px;
        width: 60px;
        height: 80px;
      }

      .title {
        text-align: left;
        margin-top: 15px;
        color: rgba(35, 35, 35, 1);
        width: 310px;
        font-size: 16px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .del {
        text-align: left;
        margin-top: 15px;
        color: rgba(80, 80, 80, 1);
        font-size: 12px;
        width: 310px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }

    }

    .new-list-layout {
      overflow: scroll;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

    }

    img {
      height: 435px;
      margin-right: 10px;
      object-fit: cover;
      flex-shrink: 0;
    }
  }
}
</style>
